<template>
  <div id="participant-addupdate-addsubevents-dialog" class="custom-modal">
    <HolaconLottie v-if="loading == 'created'" class="w-100" key="create-loading" />

    <div class="modal-body" v-else key="content-loading">
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="registerform-input-container">
            <div class="title">
              <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addDialogs.subEvent") }}</label>
              <!-- <el-tooltip content="Content" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip> -->
            </div>
            <el-select v-model="form.subEventID" clearable @clear="form.subEventID = null">
              <el-option v-for="subevent in $store.state.subevents.items" :key="subevent.id" :disabled="selectedSubEvents.some(x => x.subEventID == subevent.id)" :label="subevent.title" :value="subevent.id"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="24">
          <template v-if="availableQuestions">
            <RecursiveQuestionBuilder v-for="(question, index) in availableQuestions.filter(x => x.parentQuestionId == null && x.parentAnswerId == null)" :key="question + index" :question="question" :allQuestions="questionItems" :availableQuestions="availableQuestions" :baseValidationKey="'sub-events-' + activeSubIndex + '-questions-'" />
          </template>
        </el-col>
      </el-row>
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addDialogs.close") }}</el-button>
        <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')" v-if="form.id">
          <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addDialogs.delete") }}</el-button>
        </el-popconfirm>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="save" v-if="form.subEventID">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addDialogs.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import RecursiveQuestionBuilder from "../Questions.vue";
export default {
  components: { RecursiveQuestionBuilder },
  props: ["data", "activeSubIndex", "selectedSubEvents"],
  data() {
    return {
      form: {
        id: null,
        subEventID: null,
        status: 0,
        questions: []
      },
      questionItems: [],
      availableQuestions: [],
      timeout: null,
      loading: false,
    };
  },
  methods: {
    save() {
      var payload = {
        ...this.form,
        questions: this.availableQuestions
      };
      console.log("payload", payload);
      this.$emit("addUpdate", payload);
    }
  },
  created() {
    this.loading = "created";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      if (this.data != undefined && this.data != null) {
        this.form = this.data;
      }
      this.loading = false;
    }, 500);
  },
  watch: {
    "form.subEventID": async function(value) {
      if (value != undefined && value != null && this.availableQuestions) {
        var res = await this.$store.dispatch("getQuestionsObject", { id: this.form.subEventID, type: 5 });
        this.questionItems = res.data.data.items;
        if (this.form.questions.length > 0) {
          this.form.questions.map(x => {
            this.questionItems.find(y => y.id == x.id).answer = x.answer;
            this.questionItems.find(y => y.id == x.id).answers = x.answers;
          });
        }

        this.availableQuestions = JSON.parse(JSON.stringify(this.questionItems.filter(x => x.parentQuestionId == null && x.parentAnswerId == null)));
      } else {
        this.questionItems = [];
        this.availableQuestions = [];
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/participants/dialog/AddSubEvent.vue